import { useAppApi } from '@/lib/api';
import { useQuery } from '@/lib/useQuery';
import { errorText } from '@/lib/format';

/**
 * A review queue: list endpoint + mutations that return the updated row.
 * `mutate(apiKey, params)` replaces that row in place and resolves to it; on
 * failure it throws an Error carrying the API's human message.
 */
export function useQueue(listKey, params) {
  const query = useQuery(listKey, params);
  const { fetchApi } = useAppApi();

  const mutate = async (apiKey, body) => {
    let res;
    try {
      res = await fetchApi(apiKey, body, false);
    } catch (ex) {
      throw new Error(errorText(ex));
    }
    const row = res.data;
    query.setData((b) => (b ? { ...b, data: b.data.map((x) => (x.id === row.id ? row : x)) } : b));
    return row;
  };

  return { query, body: query.data, rows: query.data ? query.data.data : undefined, mutate };
}
